import React, {useEffect, useRef, useState} from 'react';
import {resetInvalidInputField} from "../../js/CommonHelper";
import {getItemById} from "../../helpers/ComponentHelper";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FloatingMenuPortal from "./FloatingMenuPortal";

const Select = ({label, propertyName, required, disabled, state, itemsList = [], itemName, displayNames, visible = true, allowDelete = true, tooltipProperty}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const insideTrigger = selectRef.current && selectRef.current.contains(event.target);
      const insideMenu = menuRef.current && menuRef.current.contains(event.target);
      if (!insideTrigger && !insideMenu) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleReset = () => {
    state.setCurrentItem((prev) => ({...prev, [itemName]: undefined}));
    state.setCurrentFormState((prev) => ({...prev, formSaveButtonDisabled: false}));
    state.setItemChanged((prev) => !prev);
  };

  const handleSelectChange = (item) => {
    const relatedObject = getItemById(itemsList, item.id);
    state.setCurrentItem((prev) => ({...prev, [itemName]: relatedObject}));
    state.setCurrentFormState((prev) => ({...prev, formSaveButtonDisabled: false}));
    state.setItemChanged((prev) => !prev);
    setIsOpen(false);
    setSearchTerm("");
    resetInvalidInputField(itemName);
  };

  const filteredItems = itemsList.filter((item) =>
    item && displayNames.some((displayName) =>
      item[displayName] && item[displayName].toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  if (!visible) return null;

  const currentValue = state.currentItem?.[itemName];

  return (
    <div style={{display: 'flex', alignItems: 'center', minWidth: 0}} ref={selectRef}>
      <div style={{flex: 1, minWidth: 0, position: 'relative'}}>
        <div
          ref={triggerRef}
          className="form-select"
          onClick={() => !disabled && setIsOpen((open) => !open)}
          style={{cursor: disabled ? 'default' : 'pointer', backgroundColor: disabled ? '#e9ecef' : 'white'}}
          id={itemName}
          aria-label={label}
          aria-required={required}
        >
          {currentValue && currentValue.id !== 0
            ? displayNames.map((displayName) => currentValue[displayName]).join(' ')
            : '-- Wybierz --'}
        </div>

        <FloatingMenuPortal
          open={isOpen && !disabled}
          anchorRef={triggerRef}
          menuRef={menuRef}
          minWidth={220}
          maxHeight={360}
          className="qstaff-floating-select-menu"
        >
          {(layout) => (
            <>
              <input
                type="text"
                className="form-control border-0 border-bottom rounded-0"
                placeholder="Wyszukaj..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                autoFocus
              />
              <div
                className="dropdown-menu show qstaff-floating-select-list"
                style={{maxHeight: `${Math.max(80, layout.maxHeight - 46)}px`}}
              >
                {filteredItems.length > 0 ? filteredItems.map((item) => (
                  <button
                    type="button"
                    key={item.id}
                    className="dropdown-item"
                    onClick={() => handleSelectChange(item)} title={tooltipProperty && item[tooltipProperty] ? item[tooltipProperty] : undefined}
                  >
                    {displayNames.map((displayName) => item[displayName]).join(' ')}
                  </button>
                )) : (
                  <div className="dropdown-item text-muted">Brak pasujących pozycji.</div>
                )}
              </div>
            </>
          )}
        </FloatingMenuPortal>
      </div>

      {allowDelete && (
        <button
          type="button"
          onClick={handleReset}
          disabled={!(currentValue && currentValue.id > 0)}
          className="btn btn-outline-danger"
        >
          <FontAwesomeIcon icon={faTrashAlt}/>
        </button>
      )}
    </div>
  );
};

export default Select;

